import { render, staticRenderFns } from "./RouterButton.vue?vue&type=template&id=ae67256a&"
import script from "./RouterButton.vue?vue&type=script&lang=js&"
export * from "./RouterButton.vue?vue&type=script&lang=js&"
import style0 from "./RouterButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports